// extracted by mini-css-extract-plugin
export var buttonbox = "index-module--buttonbox--w6P64";
export var container = "index-module--container--zzOpt";
export var descriptionBox = "index-module--descriptionBox--2JM5Q";
export var imageBox = "index-module--imageBox--NwiMD";
export var subtitle = "index-module--subtitle--6-7j+";
export var title = "index-module--title--Lc0RA";
export var vCenter = "index-module--vCenter--OsjK1";